/* Set your chart color scale here */

import { scaleQuantize } from "d3-scale";
import { interpolateGnBu } from "d3-scale-chromatic";
import _ from "lodash";

// FILL COLORS
const lightGray = "#E5E2E0";
const wapoGray = "#4B4238";
const fontGray = "#4a4a4a";

// Don't forget to adjust these settings based on your data.
const range = _.range(0.1, 0.7, 0.15);
const customColors = range.map((item) => interpolateGnBu(item));
export const colorFillScale = scaleQuantize()
  .domain([65, 100])
  .range(customColors)
  .unknown(lightGray);

// This can be useful if you need to tweak font colors for better contrast with fill colors.
export const colorTextScale = scaleQuantize()
  .domain([65, 100])
  .range([fontGray])
  .unknown(wapoGray);
